// Letter settings configuration based on English language Scrabble-like scoring
// Structure: { letter, points, isVowel, isRare, isSpecial, super_rare, frequency }

// Game speed increase configuration - DEPRECATED (removed for daily challenge format)
// export const speedIncreaseSettings = {
//   intervalSeconds: 5,        // Increase speed every 5 seconds
//   increaseAmount: 0.2,       // Increase by 0.2 units each interval
//   startingSpeed: 1.0,        // Starting base speed
//   maxSpeed: 3.0              // Maximum speed cap
// };

// Letter generation level rules - NEW SYSTEM
export const LEVEL_RULES = {
  easy: {
    rare: 3,           // 3 rare letters per generation (reduced from 5)
    notRare: 12,       // 12 common letters per generation
    mandatoryE: true,  // Always include at least one E
    duplicateCap: 2,   // Max 2 of same letter
    description: 'Easy mode: More common letters, guaranteed E'
  },
  normal: {
    rare: 5,           // 5 rare letters per generation (current default)
    notRare: 10,       // 10 common letters per generation
    mandatoryE: true,  // Always include at least one E (NEW RULE)
    duplicateCap: 2,   // Max 2 of same letter
    description: 'Normal mode: Balanced distribution, guaranteed E'
  },
  hard: {
    rare: 7,           // 7 rare letters per generation (increased challenge)
    notRare: 8,        // 8 common letters per generation
    mandatoryE: false, // E not guaranteed - makes word formation harder
    duplicateCap: 2,   // Max 2 of same letter
    description: 'Hard mode: More rare letters, E not guaranteed'
  }
};

export const defaultLetterSettings = {
  // Common vowels - high frequency, balanced weights
  A: { letter: "A", points: 1, isVowel: true, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  E: { letter: "E", points: 1, isVowel: true, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  I: { letter: "I", points: 1, isVowel: true, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  O: { letter: "O", points: 1, isVowel: true, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  U: { letter: "U", points: 1, isVowel: true, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },

  // Common consonants - balanced weights  
  B: { letter: "B", points: 3, isVowel: false, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  C: { letter: "C", points: 3, isVowel: false, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  D: { letter: "D", points: 2, isVowel: false, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  G: { letter: "G", points: 2, isVowel: false, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  H: { letter: "H", points: 4, isVowel: false, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  L: { letter: "L", points: 1, isVowel: false, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  M: { letter: "M", points: 3, isVowel: false, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  N: { letter: "N", points: 1, isVowel: false, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  P: { letter: "P", points: 3, isVowel: false, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  R: { letter: "R", points: 1, isVowel: false, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  S: { letter: "S", points: 1, isVowel: false, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  T: { letter: "T", points: 1, isVowel: false, isRare: false, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },

  // Rare consonants - normal rare frequency
  F: { letter: "F", points: 4, isVowel: false, isRare: true, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  K: { letter: "K", points: 5, isVowel: false, isRare: true, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  V: { letter: "V", points: 4, isVowel: false, isRare: true, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },
  W: { letter: "W", points: 4, isVowel: false, isRare: true, isSpecial: false, super_rare: false, frequency: 100, weight: 1.0 },

  // PROBLEM LETTER: Y - Significantly reduced weight to fix 13.26% frequency issue
  // Analysis showed Y appearing in 100% of generations at 13.26% frequency
  // Reducing weight from 1.0 to 0.3 should bring it down to ~3-4% target range
  Y: { letter: "Y", points: 4, isVowel: true, isRare: true, isSpecial: false, super_rare: false, frequency: 100, weight: 0.3 },

  // Super-rare letters - special upgrade mechanism (10% chance, max 1 per generation)
  J: { letter: "J", points: 8, isVowel: false, isRare: false, isSpecial: false, super_rare: true, frequency: 100, weight: 1.0 },
  Q: { letter: "Q", points: 10, isVowel: false, isRare: false, isSpecial: false, super_rare: true, frequency: 100, weight: 1.0 },
  X: { letter: "X", points: 8, isVowel: false, isRare: false, isSpecial: false, super_rare: true, frequency: 100, weight: 1.0 },
  Z: { letter: "Z", points: 10, isVowel: false, isRare: false, isSpecial: false, super_rare: true, frequency: 100, weight: 1.0 },

  // Danish letters - special characters used in Danish language
  // Weight reduced from 1.0 to 0.3 to match actual Danish frequency (Æ: 0.87%, Ø: 0.94%, Å: 1.19%)
  // These letters appear in ~1% of Danish text, not 15% like common vowels (E: 15.45%)
  // Marked as isRare: true to reflect actual language statistics and prevent over-representation
  // This follows the same pattern as Y (reduced from 1.0 to 0.3 to fix frequency issues)
  Æ: { letter: "Æ", points: 3, isVowel: true, isRare: true, isSpecial: true, super_rare: false, frequency: 100, weight: 0.3 },
  Ø: { letter: "Ø", points: 4, isVowel: true, isRare: true, isSpecial: true, super_rare: false, frequency: 100, weight: 0.3 },
  Å: { letter: "Å", points: 4, isVowel: true, isRare: true, isSpecial: true, super_rare: false, frequency: 100, weight: 0.3 }
};

// Alternative scoring systems can be added here
export const alternativeLetterSettings = {
  // Example: Different point values for a variant game mode
  scrabbleClassic: {
    A: { letter: "A", points: 1, isVowel: true, isRare: false, isSpecial: false, frequency: 100 },
    B: { letter: "B", points: 3, isVowel: false, isRare: false, isSpecial: false, frequency: 100 },
    // ... can be extended with different scoring
  }
};

// Utility functions for working with letter settings
export const getLetterPoints = (letter, settings = defaultLetterSettings) => {
  return settings[letter]?.points || 0;
};

export const getLetterInfo = (letter, settings = defaultLetterSettings) => {
  return settings[letter] || null;
};

export const getAllVowels = (settings = defaultLetterSettings) => {
  return Object.values(settings).filter(letter => letter.isVowel);
};

export const getAllRareLetters = (settings = defaultLetterSettings) => {
  return Object.values(settings).filter(letter => letter.isRare);
};

export const getAllSuperRareLetters = (settings = defaultLetterSettings) => {
  return Object.values(settings).filter(letter => letter.super_rare);
};

export const getAllNotRareLetters = (settings = defaultLetterSettings) => {
  return Object.values(settings).filter(letter => !letter.isRare);
};

export const getLettersArray = (settings = defaultLetterSettings) => {
  return Object.keys(settings);
};

// Graphics utilities for letter and number images
// DEPRECATED: Use imageLoader.js instead for dynamic imports
// These functions are kept for backwards compatibility but use async imports
export const getLetterImagePath = async (letter) => {
  const asciiCode = letter.charCodeAt(0);
  try {
    const imageModule = await import(`../assets/l_${asciiCode}.png`);
    return imageModule.default;
  } catch (error) {
    console.warn(`Letter image not found for ${letter} (ASCII ${asciiCode})`);
    return null;
  }
};

export const getNumberImagePath = async (number) => {
  if (number >= 1 && number <= 10) {
    try {
      const imageModule = await import(`../assets/n_${number}.png`);
      return imageModule.default;
    } catch (error) {
      console.warn(`Number image not found for ${number}`);
      return null;
    }
  }
  return null;
};

// Helper to get both letter and number images for a letter
// DEPRECATED: Use imageLoader.js instead
export const getLetterGraphics = async (letter, settings = defaultLetterSettings) => {
  const letterInfo = getLetterInfo(letter, settings);
  return {
    letterImage: await getLetterImagePath(letter),
    numberImage: letterInfo ? await getNumberImagePath(letterInfo.points) : null,
    points: letterInfo ? letterInfo.points : 0
  };
};
